import Reflux from 'reflux';
import React from 'react';
import ReactTooltip from 'react-tooltip';
import RcIf, {RcElse} from 'rc-if';
import AppActions from '../../AppActions';

export default class TopicHeader extends Reflux.Component {
    constructor (props) {
        super(props);
        this.state = {
            loadingOptions: props.loadingOptions,
            globalTopic: props.globalTopic,
            currentTopic: props.currentTopic,
            topicActivity: props.topicActivity,
            isTopicFaved: props.isTopicFaved
        };
    }
    componentWillReceiveProps (newProps) {
        const newState = {
            loadingOptions: newProps.loadingOptions,
            globalTopic: newProps.globalTopic,
            currentTopic: newProps.currentTopic,
            topicActivity: newProps.topicActivity,
            isTopicFaved: newProps.isTopicFaved
        };
        this.setState(newState);
    }
    favTopic = () => {
        if (this.state.isTopicFaved) {
            AppActions.removeTopicFromListByName(this.state.currentTopic.title, 'favorites');
        } else {
            AppActions.addToTopicListByName(this.state.currentTopic.title, 'favorites');
        }
    }
    render = () => {
        return (
          <RcIf if={!this.state.loadingOptions}>
            <div className='row headerTopic space-top'>
              <div className='container-gral relative'>
                <RcIf if={this.state.globalTopic} >
                  <div className='box-ri'>
                    <img src='/images/icons/global-ribbon.svg' />
                  </div>
                </RcIf>
                <div className='col s12'>
                  <h1>{this.state.currentTopic.title || this.state.topic}</h1>
                  <div className='createdby'>
                    <p>Participaciones: <span>{this.state.topicActivity.creations || 0}</span></p>
                    <p>Opciones elegidas: <span>{this.state.topicActivity.relatedOptions || 0}</span></p>
                  </div>
                  <a className='favTopic' onClick={this.favTopic}>
                    <RcIf if={this.state.isTopicFaved}>
                      <span data-for='removefav' data-tip='Elminar de favoritos'><img src='/images/icons/fav-active.svg' />
                        <ReactTooltip place='left' type='dark' effect='solid' id='removefav' />
                      </span>
                      <RcElse>
                        <span data-for='addfav' data-tip='Añadir a favoritos'><img src='/images/icons/fav-inactive.svg' />
                          <ReactTooltip place='left' type='dark' effect='solid' id='addfav' />
                        </span>
                      </RcElse>
                    </RcIf>
                  </a>
                </div>
              </div>
            </div>
            <RcElse>
              <div className='row headerTopic space-top loaderHeader'>
                <img src='/images/loaders/header-load.png' className='fill-width' />
              </div>
            </RcElse>
          </RcIf>
        );
    }
}



// WEBPACK FOOTER //
// ./src/sections/topic/TopicHeader.js